import { render } from "./ThreeBackground.vue?vue&type=template&id=1b52b3e6&scoped=true"
import script from "./ThreeBackground.vue?vue&type=script&lang=js"
export * from "./ThreeBackground.vue?vue&type=script&lang=js"

import "./ThreeBackground.vue?vue&type=style&index=0&id=1b52b3e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b52b3e6"]])

export default __exports__